export class AutoSearch {
    
    public static SavedSearchLimit:number=10;
    public static onSubmitKeywordsNotExistError:string="Please fill what are you looking for";
    public static SearchRefreshUrl:string="/search/refreshing";
    public static OnSubmitSearchTypeNotExistError:string="Please select search type";
    
}